export const DpBillsReportMapper = (resp) => {
    if (resp) {
        return resp.map((x) => {
            let newQty = 0;
            if (!!x.qty)
                newQty = parseFloat(x.qty.replace(/[()]/g, ''));
            return {
                txnDate: x.txnDate,
                isin: x.isin,
                instrument: x.instrument,
                chargesDetails: x.chargesDetails,
                qty: newQty,
                charges: x.charges,
                taxes: x.taxes,
                totalCharges: x.totalCharges,
            };
        });
    }
    return [];
};
